<!-- 数据采集 -->
<template>
  <div class="gather">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <!-- 方案简介 -->
    <Introduction :title="propsCon.title" :content="propsCon.content" :image="propsCon.img"></Introduction>
    <!-- 应用场景 -->
    <AppScene></AppScene>
    <!-- 技术架构 -->
    <TitleImg :title="titleImg.title" :image="titleImg.img" :wwidth="titleImg.wwidth"></TitleImg>
    <!-- 方案优选 -->
    <div class="gatherPlay">
      <h3 class="h3">方案优势</h3>
      <ListItem :modelList="modelList" class="listModel"></ListItem>
    </div>
    <!-- 提交方案咨询 -->
    <div class="subPlay">
      <el-button type="primary" icon="el-icon-s-order">提交方案咨询</el-button>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Introduction from '../components/Introduction'
import AppScene from '../components/AppScene'
import TitleImg from '../components/TitleImg'
import ListItem from '../components/ListItem'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Introduction, AppScene, TitleImg, ListItem, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '设备监控与数据采集',
        bgImg: require('../assets/images/u1787.png'),
        content:
          '通过物联网技术与设备对接，基于数字孪生的企业中控系统能够方便的数据采集，通过与数据库一起使用，多端数据呈现，便于查看历史数据。',
        bl: true,
      },
      propsCon: {
        title: '方案简介',
        content: [
          '企业上云是指企业通过网络,依托云平台IaaS及PaaS服务，联合生态伙伴共同打造设备在线监测和数据采集分析系统解决方案。结合自身行业平台经验和企业云服务能力，通过运用工业知识融合互联网技术与数据科学，为客户打造卓越的“云+数”战略的设备在线监测应用解决方案。设备在线监测和数据采集应用提供设备的状态监测、关键参数监测、能效管理、异常报警等服务。帮助管理人员全面、准确评估重要设备工作情况，协助技术人员评估关键设备的实时性能，为维护人员为设备维修保养提供数据支持。可有效降低设备运行能耗，提高设备运维效率，有效减少企业设备非计划停机，减少因为停机带来的产能损失，提高设备寿命，实现生产设备全生命周期健康管理，为企业带来显著的经济效益。 以及跨国家、跨地域、跨行业、跨企业的全球信息互联互通能力，是整个工业互联网网络实现互联互通的关键基础设施。主要由三要素组成：一是标识，这就相当于机器、物品的“身份证”；二是标识服务，即利用标识，对机器和物品进行唯一性的定位和信息查询，是实现全球供应链系统和企业生产系统的精准对接、产品的全生命周期管理和智能化服务的前提和基础；三是标识管理，即通过国家工业互联网标识解析体系，实现标识的申请、注册、分配、备案，为机器、物品分配唯一的编码。',
          '·将结构化数据通过时序存储解决大量设备接入和大量数据处理的运算压力问题。',
          '·应用大数据分析方法进行预测性维护，提高预测性维护的可靠性',
          '·利用边缘计算处理“废数据”。',
          '·利用专业的云安全服务体系，保障企业数据安全。',
        ],
        img: require('../assets/images/u1794.png'),
      },
      titleImg: {
        title: '技术架构',
        img: require('../assets/images/u1869.png'),
        wwidth: '12',
      },
      modelList: [
        {
          title: '多场景、多种类设备支持',
          content: [
            '针对多种行业设备特点优化，可根据不同设备的不同特点进行定制化改造，适配多场景行业设备。',
            '支持多种设备接入形式，实现设备数据的无线采集和传输，运用各种数据展示技术，将各种设备的生产信息及时的展现出来，使生产过程更加透明化。',
          ],
          img: require('../assets/images/u1877.png'),
        },
        {
          title: '安全可靠、稳定强大',
          content: [
            '接入设备全面安全认证。利用丰富的监测知识和经验保证设备监测安全。',
            '实时掌握设备属性数据，实时记录设备故障，系统可用率高于99%。',
            '高可靠性、高抗干扰，设备监测稳定。通过预警报警反应设备的异常工作状态，及时通知相关人员解决问题，有效解决生产线的效率。',
          ],
          img: require('../assets/images/u1881.png'),
        },
        {
          title: '全托管服务支持',
          content: [
            '可选设备数据传输、存储、分析全托管服务。',
            '与大数据服务无缝对接。',
          ],
          img: require('../assets/images/u1885.png'),
        },
        {
          title: '价格优惠',
          content: [
            'SaaS应用，减少硬件和运维成本。',
            '按需付费，帮助企业降低成本。',
          ],
          img: require('../assets/images/u1889.png'),
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.gatherPlay {
  background: url('../assets/images/u1872.png') no-repeat;
  background-size: cover;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
}
.subPlay {
  text-align: center;
  padding: 60px 0;
  background-color: #fff;
}
</style>
